import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZUid } from "src/types/zUid";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { Button, Empty, Switch } from "antd";
import { FileImageOutlined, SelectOutlined } from "@ant-design/icons";
import { ImageCarousel } from "src/components/ImageCarousel";
import { ZSample2 } from "../ZSample2";
import { sample2ViewStore as store } from "./Sample2ViewStore";
import { Sample2Table } from "./Sample2Table/Sample2Table";
import { UpdatePOMsConfirm } from "./UpdatePOMsConfirm";
import styles from "./Sample2View.module.less";
import { ResizableHorizPart } from "../../../../components/ResizableHorizPart";

type PropsSample2View = {
  entityId: ZUid | undefined;
};

export const Sample2View: React.FC<PropsSample2View> = observer((props) => {
  const { entityId } = props;
  React.useEffect(() => {
    store.init(entityId).catch(onError);
  }, [entityId]);
  return (
    <LoaderBox
      remoteData={store.data}
      drawReady={(data) => <Inner sample={data} />}
    />
  );
});

type PropsInner = {
  sample: ZSample2;
};

const Inner: React.FC<PropsInner> = observer(({ sample }) => {
  const { imageIds } = sample;

  React.useEffect(() => {
    store.sheetStore.init();
  }, []);

  React.useEffect(() => {
    store.sheetStore.postUpdate();
  });

  return (
    <div className={styles.box}>
      <div className={styles.topLine}>
        <div className={styles.item}>
          <div>Measurement chart</div>
          <div>{sample.mcName}</div>
        </div>
        <div className={styles.item}>
          <div>Size name</div>
          <div>{sample.sizeName}</div>
        </div>
      </div>
      <div className={styles.line2}>
        <div className={styles.labelBox}>
          <label>
            <Switch
              value={store.isImageVisible}
              onChange={(v) => {
                store.setImageVisible(v);
                store.refresh();
              }}
            />
            <span>View image</span>
          </label>
        </div>
        <Button
          type="primary"
          icon={<SelectOutlined />}
          disabled={store.selected.size === 0}
          onClick={() => store.setMode("startUpdatePOMs")}
        >
          Update POMs
        </Button>
      </div>
      <div className={styles.mainLine}>
        <Sample2Table columns={store.columns} rows={sample.rows} />
        {store.isImageVisible && (
          <ResizableHorizPart>
            <div className={styles.imgBox}>
              {imageIds?.length ? (
                <ImageCarousel multiple value={imageIds} disabled readOnly />
              ) : (
                <Empty
                  description="Нет изображений"
                  image={<FileImageOutlined style={{ fontSize: 48 }} />}
                />
              )}
            </div>
          </ResizableHorizPart>
        )}
      </div>
      <UpdatePOMsConfirm
        sizeName={sample.sizeName}
        mcName={sample.mcName}
        open={store.mode === "startUpdatePOMs" || store.mode === "doUpdatePOMs"}
        close={() => {
          store.setMode(null);
          store.refresh();
        }}
        buzy={store.mode === "doUpdatePOMs"}
        start={() => store.doUpdate().catch(onError)}
      />
    </div>
  );
});
